<!-- 日期列表组件 -->
<template>
<div class="content-block">
  <div class="info-list-title" v-if="showTitle">
    <span>{{title}}</span>
    <label>{{label}}</label>
    <a href="#" v-if="showMore">更多</a>
  </div>
  <div class="info-list-content">
    <ul>
      <li v-for="info in yearMonthList">
          <div v-on:click="selectedAct(info.year)" v-bind:class="['year-item',info.year==selectedYear ? 'reduce-ico' : 'add-ico']">{{info.year}}年</div>
          <div class="sub-item" v-if="info.year==selectedYear">
              <a v-for="month in info.month" v-bind:class="['month-item',month==selectedMonth ? 'active' : '']" @click="queryPage(info.year,month)">{{month}}月</a>
          </div>
      </li>
    </ul>
  </div>
</div>
</template>
<script>
export default {
  name: 'DateList01',
  components:{},
  props: {
    showTitle: {
      type: Boolean,
      default: false
    },
    showMore: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    titleLength: {
      type: String,
      default: '16'
    },
    label: {
      type: String,
      default: ''
    },
    count: {
      type: String,
      default: '3'
    },
    yearMonthList:{
      type:Array,
      default:function(){return []}
    }
  },
  data() {
    return {
      selectedYear: 0,
      selectedMonth:0,
    }
  },
  created:function(){
    let date = new Date();
    this.selectedYear=date.getFullYear();
    this.selectedMonth=date.getMonth()+1;
  },
  methods:{
    selectedAct:function(year){
      this.selectedYear = year;
      this.selectedMonth = 0;
    },
    queryPage:function(year,month){
      this.selectedMonth = month;
      let params={};
      params.queryYear=year;
      params.queryMonth=month;
      this.$emit("queryPage",params);
      window.scrollTo(0,0);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display:block;
  position:relative;
  margin: 0px 0px 2px 0px;
  padding:0px;
  height:100%;
  text-align:left;
  //background:red;
}

.year-item{
  height:25px;
  padding-right:20px;
  font-size:12px;
  line-height:25px;
  text-align:right;
  cursor:pointer
}

.month-item{
  display:block;
  height:25px;
  padding-right:20px;
  font-size:12px;
  line-height:25px;
  text-align:right;
  cursor:pointer
}

.active{
  color:var(--color6);
  font-weight:800;
}

.add-ico{
  background-image:url(./../../assets/add.png);
  background-size: 10px 10px;
  background-repeat: no-repeat;
  background-position: right 6px;
}

.reduce-ico{
  background-image:url(./../../assets/reduce.png);
  background-size: 10px 10px;
  background-repeat: no-repeat;
  background-position: right 7px;
  color:var(--color6);
  font-weight:600;
}

</style>



// WEBPACK FOOTER //
// src/components/block/DateList01.vue